export namespace ProcessingOrders {
  export interface IProductBatchDocument {
    // supplier_certificate_product_batch_document_id: number;
    supplier_certificate_document_id: number;
    document_file: string;
    document_description: string;
    document_url?: string;
  }

  export interface IDDT {
    certification_id: number;
    ddt_file: string;
    ddt_file_name: string;
  }

  export interface IFile {
    certification_batch_id: number;
    certification_file: string;
    certification_title: string;
    certification_file_name: string;
  }

  export interface IProductBatch {
    // supplier_certificate_product_batch_id: number;
    supplier_certificate_batch_id: number;
    certification_id?: number;
    certification_batch_id?: number;
    batch_year: number;
    batch_week: number;
    serial_from: number;
    serial_to: number;
    manual_batch: string;
    qta: number;
    quantity?: number;
    documents: IProductBatchDocument[];
  }

  export interface IBatchToAdd {
    certification_product_id: number;
    supplier_certificate_batch_id: number;
    certification_batch_id: number;
    batch_year: number;
    batch_week: number;
    serial_from: number;
    serial_to: number;
    manual_batch?: string;
    qta: number;
  }

  export interface ICertificateFile {
    certification_batch_id: number;
    certification_file: string;
    certification_title: string;
    certification_file_name: string;
  }
  export interface IProductInOrder {
    supplier_certificate_product_id: number;
    product_code: string;
    product_description: string;
    quantity: number;
    is_prepared: boolean;
    is_manual_lot: boolean;
    batches: IProductBatch[];
  }
  export interface ICertification {
    supplier_certificate_id: number;
    order_number: string;
    supplier_id: number;
    order_date: string;
    delivery_date: string;
    closing_date: string | null;
    ddt_file: string;
    ddt_url: string;
    ddt_date: string;
    is_closed: boolean;
    product_count: number;
    products: IProductInOrder[];
  }

  export class Certification implements ICertification {
    supplier_certificate_id: number = 0;
    order_number = '';
    supplier_id: number = 0;
    order_date = '';
    delivery_date = '';
    closing_date: string | null = null;
    ddt_file = '';
    ddt_url: string = '';
    ddt_date: string = '';
    is_closed = false;
    product_count: number = -1;
    products: IProductInOrder[] = [];

    constructor(certification?: Partial<ICertification>) {
      if (!certification) return;
      Object.assign(this, certification);
    }
  }
}
